import fieldsHelper from '../utils/fieldsHelper';
import valueParser from './valueParser';
/**
 * Calculate the visibility of a specified field
 * @param {string} fieldId The field id for wich we calculate the visibility
 * @param {import("../logic/types").EcrionFormState} state
 */

var calculate = function calculate(fieldId, state) {
  if (!state || !state.fields) throw 'Form is not properly initialized';
  var field = state.fields[fieldId];
  if (!field) throw 'Cannot find the field with id:' + fieldId;
  var isVisibleByDefault = field.isVisible;
  var conditions = state.visibility.conditions[field.originalId || field.id]; // this is the default state of the field (visible or not)

  var conditionResult = evaluateConditions(field, conditions, state); // if the conditions are evaluated to 'true' we change the 'visibility'

  if (conditionResult) return !isVisibleByDefault;
  return isVisibleByDefault;
};
/**
 * @param {import('../logic/types').EcrionFormField} field
 * @param {Array<import("./types").VisibilityCondition>} conditions
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {boolean} The evaluation result of the conditions
 */


var evaluateConditions = function evaluateConditions(field, conditions, state) {
  if (!conditions || !conditions.length) return false;
  var result = true;
  conditions.forEach(function (condition, index) {
    var conditionResult = evaluateCondition(field, condition, state);
    var booleanOperator = index === 0 ? 'and' : condition.booleanExpr; // compose the result using the operator
    // this must be improved to allow 'grouping' of expressions

    result = booleanOperator === 'and' ? result && conditionResult : result || conditionResult;
  });
  return result;
};
/**
 * @param {import('../logic/types').EcrionFormField} field
 * @param {import("./types").VisibilityCondition} condition
 * @param {import("../logic/types").EcrionFormState} state
 * @return {boolean} The evaluation result of the condition
 */


var evaluateCondition = function evaluateCondition(field, condition, state) {
  var conditionField = findConditionFieldRelativeTo(field, condition, state);
  var left = state.data[conditionField] || '';
  var right = condition.value;
  var operator = condition.operator; //determine operands type

  var opType = operator.substring(0, 3);

  switch (opType) {
    case 'num':
      left = valueParser.tryParseNumber(left);
      break;

    case 'cur':
      left = valueParser.tryParseCurrency(left);
      right = valueParser.tryParseCurrency(right);
      break;

    case 'dat':
      left = valueParser.tryParseDate(left);
      right = valueParser.tryParseDate(right);
      break;

    default:
      //string operands
      break;
  } //evaluate


  switch (operator) {
    case 'num==':
    case 'cur==':
      return left == right;

    case 'dat==':
      if (left && right) return left.toDateString() == right.toDateString();
      return left == right;

    case 'str==':
      // string equality comparison between two 'strings'
      if (left && right && typeof left === 'string' && typeof right === 'string') return left.toLowerCase() === right.toLowerCase(); // string equality comparison between an 'array' and a 'string'

      if (Array.isArray(left) && right && typeof right === 'string') return left.indexOf(right) !== -1; // convert boolean to str

      if (typeof left === 'boolean') return left + '' == right;
      return left == right;

    case 'num!=':
    case 'cur!=':
    case 'dat!=':
    case 'str!=':
      return left != right;

    case 'num<':
    case 'cur<':
    case 'dat<':
      return left < right;

    case 'num>':
    case 'cur>':
    case 'dat>':
      return left > right;

    case 'num>=':
    case 'cur>=':
    case 'dat>=':
      return left >= right;

    case 'num<=':
    case 'cur<=':
    case 'dat<=':
      return left <= right;

    case 'strContains':
      return left.indexOf(right) != -1;

    case 'strNotContains':
      return left.indexOf(right) == -1;

    default:
      return false;
  }
};
/**
 * @param {import('../logic/types').EcrionFormField} field
 * @param {import("./types").VisibilityCondition} condition
 * @param {import("../logic/types").EcrionFormState} state
 * @return {string} The id of the condition field relative to the 'field' parameter
 */


var findConditionFieldRelativeTo = function findConditionFieldRelativeTo(field, condition, state) {
  if (!field || !field.originalId) return condition.field;
  var clones = fieldsHelper.getClones(state, state.fields[condition.field]);
  if (!clones || !clones.length) return [];

  for (var cloneIdx = 0; cloneIdx < clones.length; cloneIdx++) {
    if (fieldsHelper.hasCommonRepeatingContext(state, field, clones[cloneIdx])) return clones[cloneIdx].id;
  }

  return condition.id;
};

export default calculate;